import Api from './Api';
import resolve from '../util/Configuracao';
class TaxaApi extends Api {
  async consultarTiposDeTaxa () {
    try {
      const urlConsultarTiposDeTaxa = resolve('urlConsultarTiposDeTaxa');
      const response = await this.fetch(urlConsultarTiposDeTaxa);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestadoresTaxa (codItemTaxa) {
    try {
      const urlConsultarPrestadoresTaxa = resolve('urlConsultarPrestadoresTaxa') + codItemTaxa;
      const response = await this.fetch(urlConsultarPrestadoresTaxa);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarTaxas (codItemTaxa, codTipoTaxa, codTabela, codTipoItem, seqPrestador) {
    let taxas = [];
    let brancoAcoes = '';
    let indAtivaFormat = '';
    let arrayItensTabela = [];
    let arrayValores = [];
    try {
      const urlConsultarTaxas = resolve('urlConsultarTaxas') +
      codItemTaxa + '/' +
      codTipoTaxa + '/' +
      codTabela + '/' +
      codTipoItem + '/' +
      seqPrestador;

      const { data } = await this.fetch(urlConsultarTaxas);

      data.map(res => {
      const { codItemTaxa, codTipoTaxa, indAtiva, desTaxa, nomTipoTaxa, taxaItemTabela, taxaValor, taxaPrestador, indPodeExcluir } = res;
      indAtivaFormat = indAtiva === 'S' ? 'SIM' : 'NÃO';
      for (var i = 0; i < taxaItemTabela.length; i++) {
        arrayItensTabela.push(taxaItemTabela[i].desItemFormatado);
      }
      for (var i = 0; i < taxaValor.length; i++) {
        arrayValores.push(taxaValor[i].desValorFormatado);
      }
      
      taxas.push(Object.values({ codItemTaxa, nomTipoTaxa, desTaxa, codTipoTaxa, taxaItemTabela, arrayItensTabela, taxaValor, arrayValores, indAtivaFormat, indAtiva, brancoAcoes, taxaPrestador, indPodeExcluir }));
      arrayItensTabela = [];
      arrayValores = [];
      });      
      return taxas || [];

    } catch (error) {
      console.error(error);
    }
  }
  async incluirTaxa (taxa) {
    try {
      const urlIncluirTaxa = resolve('urlIncluirTaxa');
      const response = await this.fetch(urlIncluirTaxa, 'post', taxa);
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async alterarTaxa (taxa) {
    try {
      const urlAlterarTaxa = resolve('urlAlterarTaxa');
      const response = await this.fetch(urlAlterarTaxa, 'post', taxa);
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async excluirTaxa (codItemTaxa) {
    try {
      const urlExcluirTaxa = resolve('urlExcluirTaxa') + codItemTaxa;
      const response = await this.fetch(urlExcluirTaxa, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirTaxaPrestador (codItemTaxaPrestador) {
    try {
      const urlExcluirTaxaPrestador = resolve('urlExcluirTaxaPrestador') + codItemTaxaPrestador;
      const response = await this.fetch(urlExcluirTaxaPrestador, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirTaxaItemTabela (codItemTaxaItemTabela) {
    try {
      const urlExcluirTaxaItemTabela = resolve('urlExcluirTaxaItemTabela') + codItemTaxaItemTabela;
      const response = await this.fetch(urlExcluirTaxaItemTabela, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }

}
export default TaxaApi;
